import { useState, useContext } from 'react';
import { Row, Col, Nav } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import AppContext from '../../services/appContext';
import { exemptionTypes } from '../../services/exemptions';
import { MEDSTAR_ASSOCIATION_TYPE__STUDENT, MEDSTAR_ASSOCIATION_TYPE__UNKNOWN, MEDSTAR_ASSOCIATION_TYPE__VENDOR } from '../../sitel/commons/utilities/medstarAssociationType';
import { SectionTitle } from '../../sitel/demon/ui/atoms';
import MoveToNextStepButton from './startFlowButtons';

export default function MedicalTab() {
  const appData = useContext(AppContext);
  const { user } = useOutletContext();

  //left column, blue lighted link
  const [newRequest, setNewRequest] = useState(exemptionTypes.medFluVax);
  let JumboText = Jumb[newRequest];

  return (
    <Row>
      <Col md='3' className='p-4'>
        <Nav variant='pills' activeKey={newRequest} className='flex-column flex-column text-center text-md-start' onSelect={(selectedKey) => setNewRequest(selectedKey)}>
          <Nav.Item>
            <Nav.Link eventKey={exemptionTypes.medFluVax}>Flu Vaccine</Nav.Link>
          </Nav.Item>
       {/*Silence for now   <Nav.Item>
            <Nav.Link eventKey={exemptionTypes.medCovidVax}>COVID-19 Vaccine</Nav.Link>
          </Nav.Item> */}
          {/* TODO -  Remove the COVID 19 Booster Exemption Type on medical and religious tabs - see ticket OH-175 */}
          {/* <Nav.Item>
            <Nav.Link eventKey={exemptionTypes.medCovidBooster}>
              COVID-19 Booster
            </Nav.Link>
          </Nav.Item> */}
          <Nav.Item>
            <Nav.Link eventKey={exemptionTypes.medN95Fit}>N95 Fit Test</Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
      <Col md='9'>
        <div className='px-5 pb-5 m-4 border-start'>{JumboText(appData.userCurrentOhrequests, user)}</div>
      </Col>
    </Row>
  );
}

const Jumb = {
  [exemptionTypes.medFluVax]: function (allCurrentRequests, user) {
    return (
      <div className='jumbotron mt-2 mb-2'>
        <SectionTitle>
          <b>Medical exemption request process for flu vaccination</b>
        </SectionTitle>
        <p>When requesting a medical exemption from the flu vaccination, you must submit a completed:</p>
        <ul>
          <li>Exemption request form (this form)</li>
          <li>
            <a href={process.env.PUBLIC_URL + '/docs/medical_provider_form_influenza.pdf'} target='_blank' rel='noreferrer'>
              Influenza Medical Provider Certification form,{' '}
            </a>
            signed by your primary healthcare provider, describing the nature, duration, and severity of your medical condition, and an explanation as to why your condition prevents you from receiving the flu vaccine
          </li>
        </ul>
        <p>Supporting medical documentation must include information that supports the rationale for granting the exemption (e.g., results of an allergy test).</p>
        {/* TOBEDELETED user.medstar_association_type === MEDSTAR_ASSOCIATION_TYPE__UNKNOWN */}
        {user.medstar_association_type === MEDSTAR_ASSOCIATION_TYPE__UNKNOWN ? <p>As a non-MedStar employee requesting a medical exemption, you must first apply for an exemption from your employer. If your employer approves a medical exemption, you must submit a copy of your employer’s policy AND documentation of your approved exemption to MedStar for review.</p> : null}
        {user.medstar_association_type === MEDSTAR_ASSOCIATION_TYPE__VENDOR ? <p>As a non-MedStar employee requesting a medical exemption, you must first apply for an exemption from your employer. If your employer approves a medical exemption, you must submit a copy of your employer’s policy AND documentation of your approved exemption to MedStar for review.</p> : null}
        {user.medstar_association_type === MEDSTAR_ASSOCIATION_TYPE__STUDENT ? <p>As a non-MedStar employee requesting a medical exemption, you must first apply for an exemption from your school. If your school approves a medical exemption, you must submit a copy of your school’s policy AND documentation of your approved exemption to MedStar for review.</p> : null}
        <p>If necessary, you may be asked to sign a Release of Information form to allow further discussion with your healthcare provider.</p>

        <MoveToNextStepButton exemptionType={exemptionTypes.medFluVax} allCurrentRequests={allCurrentRequests} />
      </div>
    );
  },

  [exemptionTypes.medCovidVax]: function (allCurrentRequests) {
    return (
      <div className='jumbotron mt-2 mb-2'>
        <CovidText />
        <MoveToNextStepButton exemptionType={exemptionTypes.medCovidVax} allCurrentRequests={allCurrentRequests} />
      </div>
    );
  },

  [exemptionTypes.medCovidBooster]: function (allCurrentRequests) {
    return (
      <div className='jumbotron mt-2 mb-2'>
        <CovidText />
        <MoveToNextStepButton exemptionType={exemptionTypes.medCovidBooster} allCurrentRequests={allCurrentRequests} />
      </div>
    );
  },

  [exemptionTypes.medN95Fit]: function (allCurrentRequests) {
    return (
      <div className='jumbotron mt-2 mb-2'>
        <SectionTitle>
          <b>Medical, N95 Fit Test Form</b>
        </SectionTitle>
        <p>MedStar Health mandates associates whose job duties require them to perform work in respiratory isolation rooms and provide care for or perform aerosolizing generating procedures (AGP) to be fit tested for a N95 respirator. N95 fit testing requires the wearer to be clean shaven in the area where the mask contacts the skin to create a safe seal to protect the associate from exposure. You may request an exemption to this requirement for one of two reasons:</p>
        <ul className='mb-4'>
          <li>A medical reason (i.e., severe skin irritation or reaction), or</li>
          <li>A sincerely held religious belief, practice, or observance that prohibits you from shaving</li>
        </ul>
        <Row className='my-2 mb-3'>
          <Col>
           <strong>Medical exemption request process</strong>
          </Col>
        </Row>
        <p>When requesting a medical exemption from the N95 fit test, you must submit a completed:</p>
        <ul>
          <li>Exemption request form (this form).</li>
          <li>
            <a href={process.env.PUBLIC_URL + '/docs/medical_provider_form_n95.pdf'} target='_blank' rel='noreferrer'>
            N-95 Respirator Medical Exemption Provider Certification Form,
            </a>
            &nbsp;signed by your primary healthcare provider, describing the nature, duration, and severity of your medical condition, and an explanation as to why your condition prevents you from wearing an N-95 Respirator.
          </li>
        </ul>
        <p>
          Supporting medical documentation must include information that supports the rationale for granting the exemption.
          <br />
        </p>
        <p>If necessary, you may be asked to sign a Release of Information form to allow further discussion with your healthcare provider.</p>
        <MoveToNextStepButton exemptionType={exemptionTypes.medN95Fit} allCurrentRequests={allCurrentRequests} />
      </div>
    );
  },
};

function CovidText() {
  return (
    <>
      <SectionTitle>
        <b>Medical exemption request for COVID-19 vaccination or booster</b>
      </SectionTitle>

      <p>When requesting a medical exemption from the COVID-19 vaccination, you must provide the required supporting documentation. This includes a completed:</p>
      <ul>
        <li>Exemption request form (this form)</li>
        <li>
          <a href={process.env.PUBLIC_URL + '/docs/medical_provider_form_COVID19.pdf'} target='_blank' rel='noreferrer'>
            COVID-19 Medical Provider Certification form,
          </a>{' '}
          signed by your primary healthcare provider, describing the nature, duration, and severity of your medical condition, and an explanation as to why your condition prevents you from receiving the COVID-19 vaccine
        </li>
      </ul>
      <p>Supporting medical documentation must include information that supports the rationale for granting the exemption (e.g., results of an allergy test).</p>
      <p>If necessary, you may be asked to sign a Release of Information form to allow further discussion with your healthcare provider.</p>
    </>
  );
}
